import React, { PureComponent } from 'react';
import { StyleSheet } from 'react-native';
import { View } from '@dbk/ui-react-utils';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { H3 } from '@dbk/ui-text';
import { FormGroup, TextInput, Message, Label } from '@dbk/ui-forms';
import Button from '@dbk/ui-buttons';
import styles from './forgot-password.styles';
import BlurModal from '../../../../../../src/components/common/blur-modal';
import VascoModal from '../../../../../../src/screens/auth/vasco/vasco-modal';

class ForgotPassword extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      userId: undefined,
      emailId: undefined,
      userIdEmpty: undefined,
      showForgotPassword: undefined,
      isVisible: false,
      isGenericError: false,
      showContactRmModal: undefined,
    };
  }


  componentDidMount() {
    this.props.forgotPassword.setVerifyOTPForForgotPassword(true);
    if(document.querySelector('input[name="userIdForgot"]')){
      // document.querySelector('input[name="userIdForgot"]').focus();
    }
    if(document.querySelector('h3.forgotPwdfocus')){ // For forgot password popup focus
        document.querySelector('h3.forgotPwdfocus').focus();
    }
  }

  componentWillUnmount() {
    // this.props.forgotPassword.setVerifyOTPForForgotPasswordSuccess(false);
    // this.props.forgotPassword.setVerifyOTPForForgotPassword(false);
    // this.props.forgotPassword.setLoading(false);
    // this.props.forgotPassword.resetVariables();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.forgotPassword.isTempPwdGenerated !== this.props.forgotPassword.isTempPwdGenerated) {
      this.showSuccessPrompt();
    }
    if (prevProps.forgotPassword.isTempPwdGeneratedError !== this.props.forgotPassword.isTempPwdGeneratedError && this.props.auth.userId != null && (this.props.auth.userId === prevProps.auth.userId)) {
      this.showErrorPrompt();
    }
    // if (prevProps.forgotPassword.verifyOTPForForgotPasswordSuccess !== this.props.forgotPassword.verifyOTPForForgotPasswordSuccess &&
    //   this.props.forgotPassword.verifyOTPForForgotPasswordSuccess) {
    //   // API call to generate and send new temprorary password to user’s email

    //   this.props.forgotPassword.generateTempPassword(this.props.auth.userId, this.props.auth.emailId);
    // }
  }

  saveUserId = (e) => {
    const value = e.target.value;
    let newValue = value.replace(/^\s+|\s+$/g, '');
    newValue = newValue.toUpperCase();
    this.props.auth.setUserId(newValue);
    this.setState({ ...this.state, userId: newValue })
  }

  saveEmailId = (e) => {
    const value = e.target.value;
    const newValue = value.replace(/^\s+|\s+$/g, '');
    this.props.auth.setEmailId(newValue);
    this.setState({ ...this.state, emailId: newValue })

  }

  // API call to initiate Reset Password and check user eligibility
  requestInitiateResetPassword = (userId, emailId) => {
    this.props.forgotPassword.initiateResetPassword(userId, emailId);
    if(document.querySelector('.invalid-credentials')){ 
      document.querySelector('.invalid-credentials').focus();
    }
  }

  resetVariables = () => {
    this.props.auth.setUserId('');
    this.props.auth.setEmailId('');
    this.props.forgotPassword.resetVariables();
  }

  showContactRmModal = () => {
    this.setState({ showContactRmModal: true });
  }

  hideContactRMModal = () => {
    this.setState({ showContactRmModal: false });
  }

  showForgotPasswordPage = () => {
    const {
      i18n: { messages },
      forgotPassword: { errorMessage, errorText, loading, attemptCountHasExceeded, wrongResetPwdAttemptCount },
      auth: { userId, emailId, channel }
    } = this.props;
    const {
      userIdEmpty,
    } = this.state;

    // const formGroupLastMargin = styles.formGroupLastMargin;
    const formGroupMargin = !userIdEmpty ? styles.formGroup : styles.formGroupErrorMargin;
    const formGroupLastMargin = styles.formGroupLastMargin;
    const showAttemptCountError = attemptCountHasExceeded - wrongResetPwdAttemptCount;

    return (
      <View className="padding-right-40">
        <H3 className="pad-top-bottom-10 margin-top-1 forgotPwdfocus" tabIndex={0} arial-label={messages['app.forgotPassword.title.forgotPassword']}>
          {messages['app.forgotPassword.title.forgotPassword']}
        </H3>
        <View className="margin-top-20">
          <Text size="large" className="pad-top-bottom-10" tabIndex={0} arial-label={messages['app.forgotPassword.description']}>
            {messages['app.forgotPassword.description']}
          </Text>
        </View>
        <View className="LoginForm">
          <FormGroup className="pad-top-20">
            <View className="pad-top-20 pad-bottom-5"></View>
            <View className='form__input-wrapper' style={StyleSheet.flatten(styles.inputWrapper)}>
              <TextInput
                label={messages['app.forgotPassword.label.username']}
                style={StyleSheet.flatten(styles.input)}
                textId="input-userId"
                size={"large"}
                name="userIdForgot"
                value={this.state.userId}
                autoComplete="off"
                // placeholder={messages['app.forgotPassword.placeholder.enterUsername']}
                onChange={this.saveUserId}
                autoCapitalize='none'
                autoCorrect={false}
                zIndex={-1}
                selectTextOnFocus={false}
                caretHidden={false}
                contextMenuHidden={false}
              />
            </View>

          </FormGroup>
          <FormGroup style={StyleSheet.flatten(formGroupLastMargin)}>
            <View className="pad-top-20 pad-bottom-5"></View>
            <View className='form__input-wrapper'>
              <TextInput
                label={messages['app.forgotPassword.label.emailAddress']}
                style={StyleSheet.flatten(styles.input)}
                textID="input-email"
                size={"large"}
                name="emailId"
                autoComplete="off"
                value={this.state.emailId}
                // placeholder={messages['app.forgotPassword.placeholder.enterEmail']}
                onChange={this.saveEmailId}
                autoCorrect={false}
                zIndex={-1}
                keyboardType="email-address"
                selectTextOnFocus={false}
                caretHidden={false}
                contextMenuHidden={false}
              />
            </View>
          </FormGroup>
          <View className="text-center pad-top-40" style={StyleSheet.flatten(styles.padTop40)}>
            <Button fullWidth size='large'
              disabled={!this.state.userId || !this.state.emailId || loading}
              loading={loading}
              onPress={() => this.requestInitiateResetPassword(this.state.userId, this.state.emailId)}
            >
              {messages['app.reset.forgotPassword.tempPwd']}
            </Button>
          </View>
        </View>

        {/* <div >
          <H2 secondary className="pad-top-bottom-10 Login__Title">
            {messages['app.forgotPassword.title.forgotPassword']}
          </H2>
        </div> */}

        {errorMessage && <span tabIndex={errorMessage ? 0 : -1} role="alert" className='invalid-credentials'aria-label={errorMessage}><Message size="none" className="userError" style={StyleSheet.flatten(styles.userError)} type="error" 
        > {errorMessage}
        </Message></span>}
        

        {/*  <div className="margin-top-20">
          <Text secondary className="pad-top-bottom-10">
            {messages['app.forgotPassword.description']}
          </Text>
        </div>
        <View className="LoginForm">
          <FormGroup className="pad-top-20">
            <Label style={StyleSheet.flatten(styles.labelStyle)}>{messages['app.forgotPassword.label.username']}</Label>
            <View className='form__input-wrapper' style={StyleSheet.flatten(styles.inputWrapper)}>
              <TextInput
                style={StyleSheet.flatten(styles.input)}
                textId="input-userId"
                size={ channel === CHANNEL_TYPES.WEB ? "large" : ""}
                name="userId"
                value={userId}
                placeholder={messages['app.forgotPassword.placeholder.enterUsername']}
                onChange={this.saveUserId}
                autoCapitalize='none'
                autoCorrect={false}
                zIndex={-1}
                selectTextOnFocus={false}
                caretHidden={false}
                contextMenuHidden={false}
              />
            </View>

          </FormGroup>
          <FormGroup style={StyleSheet.flatten(formGroupLastMargin)}>
            <Label style={StyleSheet.flatten(styles.labelStyle)}>{messages['app.forgotPassword.label.emailAddress']}</Label>
            <View className='form__input-wrapper'>
              <TextInput
                style={StyleSheet.flatten(styles.input)}
                textID="input-email"
                size={ channel === CHANNEL_TYPES.WEB ? "large" : ""}
                name="emailId"
                value={emailId}
                placeholder={messages['app.forgotPassword.placeholder.enterEmail']}
                onChange={this.saveEmailId}
                autoCorrect={false}
                zIndex={-1}
                keyboardType="email-address"
                selectTextOnFocus={false}
                caretHidden={false}
                contextMenuHidden={false}
              />
            </View>
          </FormGroup>
        </View>

        <View className="text-center pad-top-10">
          <Button fullWidth size='large'
            disabled={!this.props.auth.userId || !this.props.auth.emailId || loading}
            onPress={() => this.requestInitiateResetPassword(this.props.auth.userId, this.props.auth.emailId)}>
            {messages['app.forgotPassword.button.requestPassword']}
          </Button>
        </View>

        <div className="text-center pad-top-10 pad-bottom-10">
          <span className="inline-link" style={{ color: PALETTE.primaryActive }} onClick={this.showContactRmModal}>
            {messages['app.forgotPassword.forgotUsername']}
          </span>
        </div> */}

        {/* {initiateResetPwdResultValid === true && this.props.forgotPassword.loading &&
          <ActivityIndicator
            animating
            color={PALETTE.primaryText}
            size="large" className="pad-top-50"
          />
        } */}

        {this.props.vascoauthentication.isVascoModalVisible && <VascoModal />}


      </View>
    );
  }

  navigateToLogin = () => {
    this.props.hideGenericErrorModal(true);
  }

  hideGenericErrorModal = () => {
    this.props.auth.setUserId('');
    this.props.auth.setEmailId('');
    this.props.forgotPassword.setBlurModalError(false);
  }

  showGenericErrorPrompt = () => {
    const { i18n: { messages }, } = this.props;
    return (
      <View >
        <BlurModal
          visible={this.props.forgotPassword.blurModalError}
          doneVisible={false}
          backVisible={false}
          headerChildren={<Text size="large" secondary>{messages['app.forgotPassword.genericErrorTitle']}</Text>}
          onDone={() => this.hideGenericErrorModal()}
        >
          <View>
            <Text
              secondary >{messages['app.forgotPassword.genericError']}</Text>
            <View className="margin-top-20 margin-bottom-20 small-12 medium-push-4 medium-4 center">
              <Button
                fullWidth size='large'
                onPress={() => this.hideGenericErrorModal()} >
                {messages['app.forgotPassword.button.ok']}
              </Button>
            </View>
          </View>
        </BlurModal>
      </View>
    )
  }

  render() {
    const {
      i18n: { messages },
      forgotPassword: { initiateResetPwdResultValid, blurModalError, verifyOTPForForgotPasswordSuccess, generateTempPasswordResponse },
    } = this.props;

    // if (verifyOTPForForgotPasswordSuccess && generateTempPasswordResponse !== null
    // ) {
    //   return <div>{"<ResetPassword />"}</div>
    // }
    return (
      <View>
        {this.showForgotPasswordPage()}
        {/* {showContactRmModal &&
              <Modal
                visible={this.showContactRmModal}
                isActive={this.state.showContactRmModal}
                onClose={this.hideContactRMModal}
                header={
                  <Text style={{ color: 'white', textAlign: 'center' }}>
                    {messages['app.login.popover.username.title']}
                  </Text>
                }
                content={
                  <Text style={{ color: 'white', textAlign: 'center' }}>
                    {messages['app.reset.forgotPassword.contactRM']}
                  </Text>
                }
              />} */}

        {/* <div id="copyrightDisclaimer" className="secondary-content text-center pad-top-10 pad-bottom-10">
              {messages['app.common.copyrightDisclaimer']}
            </div> */}
        {/* {initiateResetPwdResultValid && <VascoModal />} */}


        {/* {blurModalError && this.showGenericErrorPrompt()} */}

      </View>

    );
  }
}

export default createContainer({
  $queries: {
    onValidateToken: {
      $call: 'vascoauthentication.validateVascoPwd',
    },
    setVascoModalType: {
      $call: 'vascoauthentication.setVascoModalType',
    },
    setOTPStatus: {
      $call: 'vascoauthentication.setOTPStatus',
    },
    setOTPStatuscode: {
      $call: 'vascoauthentication.setOTPStatuscode',
    },
    changePage: { $call: 'ui.history.replace' },
    auth: {
      onLogin: { $call: 'login' },
      onValidateDevice: { $call: 'validateDevice' },
      userId: true,
      emailId: true,
      setUserId: { $set: 'userId' },
      setEmailId: { $set: 'emailId' },
      channel: true
    },
    i18n: {
      messages: true,
    },
    forgotPassword: {
      initiateResetPassword: { $call: 'initiateResetPassword' },
      initiateResetPwdResultValid: true,
      showForgotPasswordPage: true,
      errorText: true,
      errorMessage: true,
      generateTempPassword: { $call: 'generateTempPassword' },
      isTempPwdGenerated: true,
      isTempPwdGeneratedError: true,
      resetVariables: { $call: 'resetVariables' },
      loading: true,
      blurModalError: true,
      setBlurModalError: { $set: 'blurModalError' },
      verifyOTPForForgotPassword: true,
      setVerifyOTPForForgotPassword: { $set: 'verifyOTPForForgotPassword' },
      verifyOTPForForgotPasswordSuccess: true,
      setVerifyOTPForForgotPasswordSuccess: { $set: 'verifyOTPForForgotPasswordSuccess' },
      setLoading: { $set: 'loading' },
      generateTempPwdResultValid: true,
      generateTempPasswordResponse: true,
      wrongResetPwdAttemptCount: true,
      attemptCountHasExceeded: true
    },
    vascoauthentication: {
      vascoVisible: true,
      vascoAuthorised: true,
      otpStatus: true,
      statusCode: true,
    }
  },
},
)(ForgotPassword);